import { render } from "./ResultsPanel.vue?vue&type=template&id=4af9cff2&scoped=true&ts=true"
import script from "./ResultsPanel.vue?vue&type=script&lang=ts"
export * from "./ResultsPanel.vue?vue&type=script&lang=ts"

import "./ResultsPanel.vue?vue&type=style&index=0&id=4af9cff2&scoped=true&lang=css"

import exportComponent from "/runner/_work/OrderpadConfigurationWeb/OrderpadConfigurationWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4af9cff2"]])

export default __exports__